/**
 * Registro de escritas locais em andamento (ou recém-confirmadas).
 *
 * Enquanto um lançamento está aqui, a sincronização de fundo (delta ao voltar
 * para a aba) e os eventos de realtime NÃO podem sobrescrever a linha local —
 * era exatamente isso que causava o efeito de "rollback": a versão antiga do
 * banco chegava depois e vencia a alteração feita pelo usuário.
 */

const pending = new Map<string, number>();

// Janela curta de proteção após a confirmação da gravação, para cobrir
// respostas de leitura que já estavam em trânsito.
const GRACE_MS = 4000;
// Segurança: nenhuma proteção dura mais que isso (evita travar dados)
const MAX_AGE_MS = 30000;

export function markPending(ids: string | string[]) {
  const list = Array.isArray(ids) ? ids : [ids];
  const now = Date.now();
  for (const id of list) pending.set(id, now + MAX_AGE_MS);
}

export function releasePending(ids: string | string[]) {
  const list = Array.isArray(ids) ? ids : [ids];
  const expiry = Date.now() + GRACE_MS;
  for (const id of list) {
    if (pending.has(id)) pending.set(id, expiry);
  }
  setTimeout(() => {
    const now = Date.now();
    for (const id of list) {
      const exp = pending.get(id);
      if (exp !== undefined && exp <= now) pending.delete(id);
    }
  }, GRACE_MS + 50);
}

export function clearPending(ids: string | string[]) {
  const list = Array.isArray(ids) ? ids : [ids];
  for (const id of list) pending.delete(id);
}

export function isPending(id: string): boolean {
  const exp = pending.get(id);
  if (exp === undefined) return false;
  if (exp <= Date.now()) {
    pending.delete(id);
    return false;
  }
  return true;
}

export function hasPending(): boolean {
  for (const id of Array.from(pending.keys())) {
    if (isPending(id)) return true;
  }
  return false;
}
